import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export function PaginationContextProvider({ children }) {
  const [itemsOnPage, setItemsOnPage] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  return (
    <Context.Provider value={{
      itemsOnPage,
      setItemsOnPage,
      pageCount,
      setPageCount,
    }}
    >
      {children}
    </Context.Provider>
  );
}

PaginationContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

export default Context;
